import { ServiceBase } from "@app/shared";
import { SpecialtyDefinition } from "./specialtyDefinitionModels";

export default class SpecialtyDefinitionService extends ServiceBase {
  public async getSpecialtyDefinitionById(specialtyDefinitionId: number): Promise<SpecialtyDefinition> {
    return await this.makeGet<SpecialtyDefinition>(`specialty-definitions/${specialtyDefinitionId}`);
  }
}
